import { z } from "zod";

export const CardSchema = z.object({
  rank: z.enum([
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "T",
    "J",
    "Q",
    "K",
    "A",
  ]),
  suit: z.enum(["diamonds", "spades", "hearts", "clubs"]),
});
export type Card = z.infer<typeof CardSchema>;

export const FlopActionSchema = z.object({
  type: z.literal("flop"),
  action: z.array(CardSchema).length(3),
});
export type FlopAction = z.infer<typeof FlopActionSchema>;
export const TurnActionSchema = z.object({
  type: z.literal("turn"),
  action: z.array(CardSchema).length(1),
});
export type TurnAction = z.infer<typeof TurnActionSchema>;
export const RiverActionSchema = z.object({
  type: z.literal("river"),
  action: z.array(CardSchema).length(1),
});
export type RiverAction = z.infer<typeof RiverActionSchema>;

export const CommunityCardActionSchema = z.union([
  FlopActionSchema,
  TurnActionSchema,
  RiverActionSchema,
]);
export type CommunityCardAction = z.infer<typeof CommunityCardActionSchema>;

export const FoldActionSchema = z.object({
  action: z.literal("fold"),
});
export type FoldAction = z.infer<typeof FoldActionSchema>;
export const CheckActionSchema = z.object({
  action: z.literal("check"),
});
export type CheckAction = z.infer<typeof CheckActionSchema>;
export const CallActionSchema = z.object({
  action: z.literal("call"),
});
export type CallAction = z.infer<typeof CallActionSchema>;
export const BetActionSchema = z.object({
  action: z.literal("bet"),
  amount: z.number(),
});
export type BetAction = z.infer<typeof BetActionSchema>;
export const RaiseActionSchema = z.object({
  action: z.literal("raise"),
  amount: z.number(),
});
export type RaiseAction = z.infer<typeof RaiseActionSchema>;

export const PlayerActionMetaSchema = z.object({
  type: z.literal("action"),
  totalBet: z.number(),
  role: z.string(),
  seatNo: z.number(),
});
export type PlayerActionMeta = z.infer<typeof PlayerActionMetaSchema>;

export const PlayerActionWithoutAmountSchema = z
  .union([FoldActionSchema, CheckActionSchema, CallActionSchema])
  .and(PlayerActionMetaSchema);
export type PlayerActionWithoutAmount = z.infer<
  typeof PlayerActionWithoutAmountSchema
>;

export const PlayerActionWithAmountSchema = z
  .union([BetActionSchema, RaiseActionSchema])
  .and(PlayerActionMetaSchema);
export type PlayerActionWithAmount = z.infer<
  typeof PlayerActionWithAmountSchema
>;

export const PlayerActionSchema = z.union([
  PlayerActionWithoutAmountSchema,
  PlayerActionWithAmountSchema,
]);
export type PlayerAction = z.infer<typeof PlayerActionSchema>;

export const ActionSchema = z.union([
  CommunityCardActionSchema,
  PlayerActionSchema,
]);
export type Action = z.infer<typeof ActionSchema>;
